/**
 * LoginWelcomeScreen — l'accueil d'un appareil sans compte enregistré (`menu`, pile déconnectée).
 *
 * Sur le design system, la première étape de la connexion EST l'accueil du livre (la lueur, le logo,
 * « Bonjour, content de vous revoir. ») et porte « Devenir tuteur » : l'écran passe donc tout de suite à
 * `login` (Wajih, 19/10). Qui le reçoit, et pourquoi sans drapeau : `welcomeBridge`
 * (`featureFlags/screenBridge.js`).
 */
import React, { useEffect } from "react"
import { View } from "react-native"
import { useIsFocused, useNavigation } from "@react-navigation/native"

export function LoginWelcomeScreen() {
    const navigation = useNavigation<{ replace: (name: string) => void }>()
    // L'accueil peut être monté sous un autre écran (une adresse `/login` ouverte directement le pose
    // dessous, ou les derniers comptes retirés sous « Qui utilise Masteur ? »). Remplacer alors poserait
    // une seconde connexion sur la pile ; on attend d'être l'écran affiché.
    const focused = useIsFocused()

    useEffect(() => {
        if (focused) navigation.replace("login")
    }, [focused, navigation])

    return <View style={{ flex: 1 }} />
}

export default LoginWelcomeScreen
